/* eslint-disable sonarjs/no-nested-functions */
import React, { PureComponent } from 'react';
import isFunction from 'lodash/isFunction';
import { connect } from 'react-redux';

export default function connectWithConditionFactory(shouldUpdateCondition) {
  return function connectWithConditionConnect(mapStateToProps, ...args) {
    return function connectWithConditionCreator(Component) {
      class ConnectWithCondition extends PureComponent {
        constructor(props) {
          super(props);

          this.proxy = function proxyMapStateToPropsAtFirstCall(state, ownProps) {
            const firstResult = mapStateToProps(state, ownProps);
            if (isFunction(firstResult)) {
              this.proxy = firstResult;
              return this.proxy(state, ownProps);
            }
            this.proxy = mapStateToProps;
            return firstResult;
          };
        }

        render() {
          const ConnectedComponent = connect(
            (state, ownProps) => {
              if (!shouldUpdateCondition(state, ownProps)) {
                return { _doNotUpdate: true };
              }
              return this.proxy(state, ownProps);
            },
            ...args
          )(Component);

          return <ConnectedComponent {...this.props} />;
        }
      }

      return ConnectWithCondition;
    };
  };
}
